module.exports = __webpack_public_path__ + "key-benefits-mobile-text.svg?6cb3e17b7c0b571d9d204f3bbb5e0800";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/key-benefits-mobile-text.svg
// module id = 123
// module chunks = 0